import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { capitalize, filter, find, toLower } from "lodash";

import { deleteOrgContract, filterData, getReport, getData, getDetails, setTab, sortData, getAuditData, setPageNumber } from "../../store/dataSlice";
import { Modal, Upload } from "antd";
import { uploadContracts } from "../../store/uploadSlice";
import { editValues, showForm } from "../../store/formSlice";
import { contextSearch, createMarkup, formatDate, highlightText } from "../../utils";
import { PageContent } from "./PageContent";
import { Button } from "../../components/Button";
import { OrgsIcon } from "../../icons/OrgsIcon";
import { VerifiedIcon } from "../../icons/VerifiedIcon";
import { UntestedIcon } from "../../icons/UntestedIcon";
import { CircleIcon } from "../../icons/CircleIcon";
import { UsersIcon } from "../../icons/UsersIcon";
import { IssuesIcon } from "../../icons/IssuesIcon";
import { Page404 } from "../../components/Page404";
import { Flex } from "../../components/Flex";
import { Paragraph, Title } from "../../components/Text";
import { FormTooltip, Tooltip } from "../../components/Tooltip";
import { ArrowBackIcon } from "../../icons/ArrowBackIcon";
import { ContractsIcon } from "../../icons/ContractsIcon";
import { EditIcon } from "../../icons/EditIcon";
import { UnknownIcon } from "../../icons/UnknownIcon";
import { PackagesIcon } from "../../icons/PackagesIcon";
import { SettingsIcon } from "../../icons/SettingsIcon";
import { IconButton } from "../../icons/IconContainer";
import { RemoveIcon } from "../../icons/RemoveIcon";
import { confirmModalOptions } from "../details/DetailsContainer";
import { GRANTS, MINOS, SYSARCH, YESNO } from "../../settings";


const PageContentContainer = ({ location, match }) => {
    const { pathname, search } = location;
    const { org, tab } = match.params;
    const page = pathname.split("/")[1];
    const dispatch = useDispatch();
    const { details, loading, context, sortColumn, sortOrder, filterOptions, currentPage, total } = useSelector(state => state.data);
    const { contractsWrite, orgWrite } = useSelector(state => state.user.grants);
    const manage = new URLSearchParams(location.search).get('manage');

    const data = useSelector(state => {
        const { data } = state.data;
        return context ? contextSearch(data, context) : data;
    });

    const tabs = {
        organisations: {
            header: <Button onClick={() => dispatch(showForm("organisations"))}>
                        <OrgsIcon small />
                        Add Organisation
                    </Button>,
            columns: [
                {
                    title: "Name",
                    dataIndex: 'name',
                    defaultSortOrder: 'ascend',
                    render: (text, record, index) => (
                        <Link to={`${pathname}/${record.key}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                },
                {
                    title: "Alias",
                    dataIndex: 'alias',
                    width: 100,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("alias") && a.alias) return a.alias.localeCompare(b.alias) }
                },
                {
                    title: "Phone",
                    dataIndex: "phone",
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("phone") && a.phone) return a.phone.localeCompare(b.phone) }
                },
                {
                    title: "Email",
                    dataIndex: "email",
                    render: (text, record, index) => (
                        <a href={`mailto: ${text}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </a>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("email") && a.email) return a.email.localeCompare(b.email) }
                }
            ],
            searchOptions:
            [
                { key: "org_name", title: "organisation name", type: "string", placeholder: "The account's company name or its part.", "max": 30 },
                { key: "org_alias", title: "organisation alias", type: "string", placeholder: "The organization's alias or its part.", "max": 3 },
                { key: "email", title: "contact email", type: "string", placeholder: "Сontact email address.", "max": 30 },
                { key: "phone", title: "contact phone", type: "string", placeholder: "Сontact phone number.", "max": 30 },
                { key: "updated_by", title: "last updated by", type: "string", placeholder: "Name of the person who was the last to update the profile data.", "max": 30 }
            ]
        },
        users: {
            header: <Button onClick={() => dispatch(showForm("users"))}>
                        <UsersIcon small />
                        Add User
                    </Button>,
            columns: [
                {
                    title: <CircleIcon />,
                    dataIndex: 'disabled',
                    render: (text, record, index) =>
                        <>
                            {text ? <UntestedIcon /> : <VerifiedIcon /> }
                        </>,
                    width: 56,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("disabled")) return (a.disabled === b.disabled )? 0 : a.disabled ? 1 : -1 }
                },
                {
                    title: "User Name",
                    dataIndex: "name",
                    defaultSortOrder: "ascend",
                    render: (text, record, index) => (
                        <Link to={`${pathname}/${record.key}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                },
                {
                    title: "E-Mail",
                    dataIndex: "email",
                    render: (text, record, index) => (
                        <a href={`mailto: ${text}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </a>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("email") && a.email) return a.email.localeCompare(b.email) }
                },
                {
                    title: "Default Organisation",
                    dataIndex: "org",
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("org") && a.org) return a.org.localeCompare(b.org) }
                },
                {
                    title: "Grant Name",
                    dataIndex: "grant",
                    width: 150,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("grant") && a.grant) return a.grant.localeCompare(b.grant) }
                },
                {
                    title: "Expired",
                    dataIndex: "expired",
                    width: 100,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("expired") && a.expired) return a.expired.localeCompare(b.expired) }
                }
            ],
            searchOptions: org
                ? null
                : [
                    { key: "email", title: "user email", type: "string", placeholder: "User's email address.", "max": 60 },
                    { key: "full_name", title: "user name", type: "string", placeholder: "User's name or its part." },
                    { key: "grant", title: "grant", type: "select", options: GRANTS, placeholder: "The name of the user grant." },
                    { key: "org_name", title: "organisation name", type: "string", placeholder: "The account's company name or its part." },
                    { key: "org_alias", title: "organisation alias", type: "string", placeholder: "The organization's alias or its part." },
                    { key: "last_updated_by", title: "last updated by", type: "string", placeholder: "Name of the person who was the last to update the profile data.", "max": 60 },
                    { key: "disabled", title: "disabled", type: "boolean", options: YESNO, placeholder: "User's account status (enabled/disabled)." },
                    { key: "grant_expired", title: "grant expired", type: "boolean", options: YESNO, placeholder: "User's grant expiration status (active/expired)." }
                ]
        },
        issues: {
            header: !org && <Button onClick={() => dispatch(showForm("issues"))}>
                <IssuesIcon small />
                Create Issue
            </Button>,
            columns: [
                {
                    title: "Issue ID",
                    dataIndex: "ref",
                    width: 150,
                    defaultSortOrder: "descend",
                    sorter: (a, b) => { if (a && a.hasOwnProperty("ref") && a.ref) return Number(a.ref.substring(a.ref.lastIndexOf("-") + 1)) - Number(b.ref.substring(b.ref.lastIndexOf("-") + 1)) },
                },
                {
                    title: "Summary",
                    dataIndex: "summary",
                    ellipsis: false,
                    render: (text, record, index) => (
                        <Link to={`${pathname}/${toLower(record.key)}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("summary") && a.summary) return a.summary.localeCompare(b.summary) }
                },
                {
                    title: "Reporter",
                    dataIndex: "reporter",
                    width: 200,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("reporter") && a.reporter) return a.reporter.localeCompare(b.reporter) }
                },
                {
                    title: "Created",
                    dataIndex: "date",
                    width: 200,
                    defaultSortOrder: "descend",
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("date") && a.date) return a.date.localeCompare(b.date) },
                },
                {
                    title: "Status",
                    dataIndex: "status",
                    width: 150,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("status") && a.status) return a.status.localeCompare(b.status) }
                }
            ]
        },
        contracts: manage
            ? {
                header: contractsWrite &&
                <Button onClick={() => dispatch(showForm("contract"))}>
                    <ContractsIcon small add />
                    Create Contract
                </Button>,
                columns: [
                    {
                        title: <CircleIcon />,
                        dataIndex: 'active',
                        render: (text, record, index) =>
                            <>
                                {text == true ? <VerifiedIcon /> : text == false ? <UntestedIcon /> : <UnknownIcon />}
                            </>,
                        width: 56,
                        sorter: (a, b) => { if (a && a.hasOwnProperty("active")) return (a.active === b.active) ? 0 : a.acrive ? 1 : -1 }
                    },
                    {
                        title: "Contract Name",
                        dataIndex: 'name',
                        defaultSortOrder: 'ascend',
                        render: (text, record, index) => (
                            <Link to={`${pathname}/${toLower(encodeURIComponent(text))}${search}`}>
                                <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                            </Link>
                            ),
                        sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                    },
                    {
                        title: "Description",
                        dataIndex: 'description',
                        render: (text, record, index) => <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />,
                        sorter: (a, b) => { if (a && a.hasOwnProperty("description") && a.description) return a.description.localeCompare(b.description) }
                    },
                    {
                        title: "Registered by",
                        dataIndex: 'registeredBy',
                        render: (text, record, index) => <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />,
                        sorter: (a, b) => { if (a && a.hasOwnProperty("registeredBy") && a.registeredBy) return a.registeredBy.localeCompare(b.registeredBy) }
                    }
                ]
            }
            : {
                title: "Organisations contracts",
                header: <>
                    {contractsWrite &&
                    <Link to={`${pathname}?manage=True`}>
                        <FormTooltip visible text="Manage contracts">
                            <IconButton background="#FFFFFF" >
                                <SettingsIcon color="var(--sp-main-color)" hoverColor="var(--sp-main-color-hover)"/>
                            </IconButton>
                        </FormTooltip>
                    </Link>}
                    {contractsWrite && orgWrite &&
                        <Button onClick={() => dispatch(showForm("contracts"))}>
                            <ContractsIcon small />
                            Apply Contract
                        </Button>}
                </>,
                footer: contractsWrite && orgWrite &&
                    <Upload
                        showUploadList={false}
                        customRequest={({ file }) => dispatch(uploadContracts(file))}
                    >
                        <Button>
                            <ContractsIcon small arrow/>
                            Upload Contracts
                        </Button>
                    </Upload>,
                columns: [
                    {
                        title: "Contract Name",
                        dataIndex: 'name',
                        defaultSortOrder: 'ascend',
                        width: 150,
                        render: (text, record, index) => (
                            <Link to={`${pathname}/${toLower(encodeURIComponent(text))}`}>
                                <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                            </Link>
                        ),
                        sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                    },
                    {
                        title: "Organisation",
                        dataIndex: 'org',
                        render: (text, record, index) => (
                            <Link to={`organisations/${record.alias}`}>
                                <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                            </Link>
                        ),
                        sorter: (a, b) => { if (a && a.hasOwnProperty("org") && a.org) return a.org.localeCompare(b.org) }
                    },
                    {
                        title: "Expiry",
                        dataIndex: "endDate",
                        defaultSortOrder: "descend",
                        width: 150,
                        render: (text, record, index) => <span dangerouslySetInnerHTML={createMarkup(highlightText(formatDate(text, "DD-MMM-YYYY"), context))} />,
                        sorter: (a, b) => { if (a && a.hasOwnProperty("endDate") && a.endDate) return a.endDate.localeCompare(b.endDate) },
                    },
                    {
                        title: "Registered by",
                        dataIndex: 'registeredBy',
                        render: (text, record, index) => <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />,
                        sorter: (a, b) => { if (a && a.hasOwnProperty("registeredBy") && a.registeredBy) return a.registeredBy.localeCompare(b.registeredBy) }
                    },
                    {
                        title: "Updated by",
                        dataIndex: 'updatedBy',
                        render: (text, record, index) => <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />,
                        sorter: (a, b) => { if (a && a.hasOwnProperty("updatedBy") && a.updatedBy) return a.updatedBy.localeCompare(b.updatedBy) }
                    },
                    {
                        dataIndex: "edit",
                        width: 50,
                        render: (text, record, index) => (
                            <EditIcon
                                color="var(--sp-label-color)"
                                hoverColor="var(--sp-paragraph-color)"
                                onClick={() => dispatch(editValues({ entity: "contracts", values: record }))}
                            />
                        )
                    },
                    {
                        dataIndex: "remove",
                        width: 50,
                        render: (text, record, index) => (
                            <RemoveIcon
                                small
                                color="var(--sp-label-color)"
                                hoverColor="var(--sp-paragraph-color)"
                                onClick={() => confirmRemovingContract(record.alias, record.name, record.org)}
                            />
                        )
                    }
                ],
                searchOptions: [
                    { key: "contract_name", title: "contract", type: "string", placeholder: "A name (or a part of) of a contract." },
                    { key: "org_name", title: "organization", type: "string", placeholder: "A name (or a part of) of an organisation." },
                    { key: "end_date_from", title: "expiration date from", type: "date", placeholder: "Starting date range of an organisation contract expiration date." },
                    { key: "end_date_to", title: "expiration date to", type: "date", placeholder: "Stopping date range of an organisation contract expiration date." },
                    { key: "email", title: "user email", type: "string", placeholder: "Email of user who registered or updated an organisation contract." }
                ]
            },
        packages: {
            header: <Button onClick={() => dispatch(showForm("packages"))}>
                <PackagesIcon small />
                Register Package
            </Button>,
            columns: [
                {
                    title: <CircleIcon />,
                    dataIndex: 'verified',
                    render: (text, record, index) =>
                        <>
                            {text == 1 ? <VerifiedIcon /> : text == 0 ? <UntestedIcon /> : <UnknownIcon />}
                        </>,
                    width: 56,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("verified") && a.verified) return a.verified.localeCompare(b.verified) }
                },
                {
                    title: "Package Name",
                    dataIndex: "name",
                    defaultSortOrder: "ascend",
                    render: (text, record, index) => (
                        <Link to={`${pathname}/${toLower(encodeURIComponent(record.key))}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                },
                {
                    title: "Version",
                    dataIndex: "version",
                    width: 100,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("version") && a.version) return a.version.localeCompare(b.version) }
                },
                {
                    title: "Release date",
                    dataIndex: "verifiedDate",
                    width: 180,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("verifiedDate") && a.verifiedDate) return a.verifiedDate.localeCompare(b.verifiedDate) }
                },
                {
                    title: "Arch",
                    dataIndex: 'sysarch',
                    width: 80,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("sysarch") && a.sysarch) return a.sysarch.localeCompare(b.sysarch) }
                },
                {
                    title: "Min OS",
                    dataIndex: 'minos',
                    width: 100,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("minos") && a.minos) return a.minos.localeCompare(b.minos) }
                },
                {
                    title: "Kit Type",
                    dataIndex: "swtype",
                    width: 150,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("swtype") && a.swtype) return a.swtype.localeCompare(b.swtype) }
                },
                {
                    title: "Restart",
                    dataIndex: "restart",
                    width: 80,
                    render: (text, record, index) => text == 1 ? "Yes" : text == 0 ? "No" : text,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("restart") && a.restart) return a.restart - b.restart}
                }
            ],
            searchOptions: [
                { key: "name", title: "package name", type: "string", placeholder: "Name or a part of the name of the package being added as it is displayed in the UI." },
                { key: "minos", title: "minimum os", type: "select", options: MINOS, placeholder: "Minimum OS version that the package can be installed on." },
                { key: "sysarch", title: "system architecture", type: "select", options: SYSARCH, placeholder: "System architecture that the package is compatible with." },
                { key: "registered_by", title: "registered by", type: "string", placeholder: "Email of the user who registered a package.", "max": 60 },
                { key: "registered_datetime_from", title: "registered date from", type: "date", placeholder: "Start date of the period which the package was registered in." },
                { key: "registered_datetime_to", title: "registered date to", type: "date", placeholder: "End date of the period which the package was registered in." },
                { key: "verified", title: "verified", type: "boolean", options: YESNO, placeholder: "Package verification status (verified or not)." },
                { key: "verified_by", title: "verified by", type: "string", placeholder: "Email of the user who verified a package.", "max": 60 },
                { key: "verified_datetime_from", title: "release date from", type: "date", placeholder: "Start date of the period which the package was verified in." },
                { key: "verified_datetime_to", title: "release date to", type: "date", placeholder: "End date of the period which the package was verified in." },
                { key: "updated_by", title: "updated by", type: "string", placeholder: "Email of the user who updated a package.", "max": 60 }
            ]
        },
        download: {
            title: "Packages Download Audit",
            pagination: true,
            columns: [
                {
                    title: "Package Name / File Name",
                    dataIndex: "packageName",
                    render: (text, record, index) => (
                        <Link to={`${pathname}/${record.auditNumber}`}>
                            <span title={text + " / " + record.filename}>
                                <Paragraph color="currentColor" dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />&nbsp;/ &nbsp;<Paragraph nowrap color="currentColor" dangerouslySetInnerHTML={createMarkup(highlightText(record.filename, context))} />
                            </span>
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                },
                {
                    title: "Version",
                    dataIndex: "version",
                    width: 100,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("version") && a.version) return a.version.localeCompare(b.version) }
                },
                {
                    title: "Arch",
                    dataIndex: 'sysarch',
                    width: 80,
                    render: (text, record, index) => (
                        <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("sysarch") && a.sysarch) return a.sysarch.localeCompare(b.sysarch) }
                },
                {
                    title: "User",
                    dataIndex: "fullName",
                    render: (text, record, index) => (
                        <Link to={`/users/${record.email}`}>
                            <span dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("email") && a.email) return a.email.localeCompare(b.email) }
                },
                {
                    title: "Organisation",
                    dataIndex: "orgName",
                    render: (text, record, index) => (
                        <Paragraph title={text} nowrap dangerouslySetInnerHTML={createMarkup(highlightText(text, context))} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("org") && a.org) return a.org.localeCompare(b.org) }
                },
                {
                    title: "Download date",
                    dataIndex: "downloadDatetime",
                    defaultSortOrder: "descend",
                    width: 180,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("downloadDate") && a.downloadDate) return a.downloadDate.localeCompare(b.downloadDate) }
                }
            ],
            searchOptions: [
                { key: "package_name", title: "package name", type: "string", placeholder: "Name or a part of the name of the package being downloaded." },
                { key: "version", title: "package version", type: "string", placeholder: "Version or a part of the version of the package being downloaded." },
                { key: "sysarch", title: "system architecture", type: "select", options: SYSARCH, placeholder: "System architecture that the package is compatible with." },
                { key: "full_name", title: "downloaded by", type: "string", placeholder: "Name or a part of the name of the user who downloaded a package.", "max": 60 },
                { key: "org_name", title: "organisation name", type: "string", placeholder: "The company name or its part.", "max": 30 },
                { key: "downloaded_datetime_from", title: "downloaded date from", type: "date", placeholder: "Start date of the period which the package was downloaded." },
                { key: "downloaded_datetime_to", title: "downloaded date to", type: "date", placeholder: "End date of the period which the package was downloaded." },
            ]
        }
    };

    useEffect(() => {
        let order = null, column = null;
        if (tabs[tab] && tabs[tab].columns) {
            let defaultSortCol = find(tabs[tab].columns, col => col.defaultSortOrder);
            if (defaultSortCol) {
                column = defaultSortCol.dataIndex;
                order = defaultSortCol.defaultSortOrder;
            }
        }
        dispatch(setTab({
            tab: tab,
            column: column,
            order: order
        }));
    }, [ org, tab, manage ]);

    useEffect(() => {
        if (org) {
            dispatch(getDetails({ page: page, org: org, tab: tab }))
        } else {
            if (!tabs[tab].pagination) {
                dispatch(getData({ tab: tab, manage: manage }));
            }
        };

        // return () => dispatch(resetData())
    }, [ org, tab, filterOptions.length, manage ]);

    useEffect(() => {
        if (tabs[tab].pagination) {
            if (page === "audit") {
                dispatch(getAuditData({ tab: tab }));
            } else {
                dispatch(getData({ tab: tab, manage: manage }));
            };
        };
    }, [ tab, currentPage, context, filterOptions.length ]);

    const tabTitle = (org && details.name) || (page === "audit" && tab)
            ? <Flex align="center" position="relative">
                <Tooltip visible text={details.name || `Back to ${page}`} placement="top">
                    <Title h4 isLoading={loading} max="250px">
                        <Link to={pathname.substring(0, pathname.lastIndexOf("/"))}>
                            {details.name || capitalize(page)}
                        </Link>
                    </Title>
                </Tooltip>
                <ArrowBackIcon />
                <Title h4 capitalize nowrap>{tabs[tab].title || tab}</Title>
            </Flex>
            : tabs.hasOwnProperty(tab) && tabs[tab].title
                ? tabs[tab].title
                : tab;

    const reportTypes = [
        { key: "pdf", title: "PDF file" },
        { key: "csv", title: "CSV file" },
        { key: "html", title: "HTML file" }
    ];

    const confirmRemovingContract = (alias, contract, org) => {
        Modal.confirm({
            ...confirmModalOptions,
            content: <Paragraph>Are you sure you want to delete the <span>{contract}</span> contract for <span>{org}</span>?</Paragraph>,
            onOk: () => dispatch(deleteOrgContract({ alias: alias, contract: toLower(contract) }))
        });
    };

    return(
        Object.keys(tabs).indexOf(tab) < 0
            ? <Page404 />
            : <PageContent
                data={data}
                title={tabTitle}
                loading={loading}
                onSearch={(value) => dispatch(filterData(value))}
                tab={tabs.hasOwnProperty(tab) ? tabs[tab] : {}}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                sortData={payload => dispatch(sortData(payload))}
                reportTypes={reportTypes}
                makeReport={({ key }) => dispatch(getReport({ tab: tab, format: key }))}
                currentPage={currentPage}
                totalRecords={total}
                setPageNumber={(number) => dispatch(setPageNumber(number))}
            />
    );
};

export { PageContentContainer };